<div class="reviews-list">
  @for (review of reviews | slice: 0 : pageSize; track $index) {
    <div class="reviews-list__item">
      @for (rating of review.ratings; track $index) {
        <div class="reviews-list__stars">
          <star-rating [rating]="rating.value" [readOnly]="true"></star-rating>
          <span class="reviews-list__rating-count">{{ rating.value }}</span>
        </div>
      }
      <div class="reviews-list__item-description">"{{ review.detail }}"</div>
      <p class="reviews-list__item-author">{{ review.nickname }}</p>
      <p class="reviews-list__item-date">
        {{ review.created_at | date: 'MMM d, y' }}
      </p>
    </div>
  } @empty {
    <p class="reviews-empty-text" translate>
      There are no reviews. You can be the first!
    </p>
  }
</div>

@if (reviews && reviews.length > 0 && pageSize < reviews.length) {
  <div class="reviews-show-more-button">
    <a translate (click)="loadMore()">Show more</a>
  </div>
}
